import type { State as RootState } from '../reducers';
import type { State as LoginV2State } from '../reducers/login-v2-reducer';
import { CheckUserNamePasswordlessType } from '../types';

export const selectLoginV2 = (state: RootState): LoginV2State => state.loginV2;

export const selectLoginV2UserActions = (state: RootState) => selectLoginV2(state).userActions;

export const selectLoginV2SelectedUserAction = (state: RootState) =>
  selectLoginV2(state).selectedUserAction;

export const selectLoginV2IsActionSelectionRequired = (state: RootState) => {
  const loginV2 = selectLoginV2(state);
  return loginV2.isUsernameChecked && loginV2.userActions.length > 1 && !loginV2.selectedUserAction;
};

export const selectLoginV2UsernameExists = (state: RootState) => {
  const selectedUserAction = selectLoginV2SelectedUserAction(state);

  return (
    !!selectedUserAction &&
    selectedUserAction.action !== 'signup' &&
    selectedUserAction.action !== 'not_permitted'
  );
};

export const selectLoginV2Identities = (state: RootState) => {
  const selectedUserAction = selectLoginV2SelectedUserAction(state);

  if (selectedUserAction?.action === 'social_login') {
    return selectedUserAction.identities;
  }

  return undefined;
};

export const selectLoginV2IsSocialBlocked = (state: RootState) => {
  const selectedUserAction = selectLoginV2SelectedUserAction(state);

  return selectedUserAction?.action === 'no_action' && selectedUserAction.social === 'disallowed';
};

export const selectLoginV2PasswordlessAvailability = (state: RootState) => {
  const selectedUserAction = selectLoginV2SelectedUserAction(state);

  if (selectedUserAction?.action === 'no_action' || selectedUserAction?.action === 'social_login') {
    return selectedUserAction.passwordless || CheckUserNamePasswordlessType.Disallowed;
  }

  return CheckUserNamePasswordlessType.Disallowed;
};

export const selectLoginV2CanSubmitPassword = (state: RootState) => {
  const selectedUserAction = selectLoginV2SelectedUserAction(state);

  if (selectedUserAction?.action === 'no_action') {
    return true;
  }

  if (selectedUserAction?.action === 'social_login') {
    return selectedUserAction.identities.password;
  }

  return false;
};

export const selectLoginV2IsLoading = (state: RootState) => {
  const loginV2 = selectLoginV2(state);
  return loginV2.isCheckingUsername || loginV2.isExecutingUserAction || loginV2.isLoggingIn;
};
